<template>
    <div class="list-table-mb standard">
        <div class="show_data" v-show="showRecentListingData">
            <div class="list">
                <!-- table title start -->
                <div class="titile list_item">
                    <div
                        class="cell address"
                    >
                        {{ $ft.uppercase($t('md-listing-list.address')) }}
                    </div>
                    <div class="cell sold_data">
                        {{
                            $ft.uppercase(
                                isSoldListing
                                    ? $t('md-listing-list.soldDate')
                                    : $t('md-listing-list.listingDate')
                            )
                        }}
                    </div>
                    <div class="cell sold_price t_right">
                        {{
                            $ft.uppercase(
                                isSoldListing
                                    ? $t('md-listing-list.soldPrice')
                                    : $t('md-listing-list.listingPrice')
                            )
                        }}
                    </div>
                </div>
                <!-- table title end -->
                <table-item
                    v-for="item in listing"
                    :key="item.id"
                    :params="item"
                ></table-item>
                <div
                    class="loading_container"
                    v-show="showRecentListingLoading"
                >
                    <Loading />
                </div>
            </div>
            <Pagination
                v-if="!showLock"
                :totalPage="totalPage"
                :pageSize="pageSize"
                :pageNum="pageNum"
                :noScroll="true"
                @pageChange="onPageChange"
            />
        </div>
        <div class="coming_container" v-show="showRecentListingComing">
            <img
                class="pic"
                src="//static.chimeroi.com/image/snapshot/v3-img-no-listing@2x.png"
                alt
            />
            <div class="desc">{{ $t('md-listing-list.comingSoon') }}</div>
        </div>
        <div class="no_data" v-show="showRecentListingNoData">
            <img
                class="pic"
                src="//static.chimeroi.com/image/snapshot/v3-img-no-listing@2x.png"
                alt
            />
            <div class="desc">{{ $t('md-listing-list.noData') }}</div>
        </div>
    </div>
</template>

<script>
import { mapState as rootMapState } from 'pinia';
import { mapState } from '@/store/helpers';
import { usePageStore } from '@/store';
import { defineAsyncComponent } from 'vue';

import TableItem from '../table-item/mobile';

import paginationMixins from '../../../_mixins/pagination/common';
import Loading from '../../../../../components/loading';
export default {
    name: 'list-table-mb',
    components: {
        Pagination: defineAsyncComponent(() =>
            import(
                /* webpackChunkName: "components/pagination"*/ '@/components/pagination/index.vue'
            )),
        'table-item': TableItem,
        Loading
    },
    props: {
        showLock: {
            type: Boolean,
            default: false
        }
    },
    mixins: [paginationMixins],
    computed: {

        ...rootMapState(usePageStore, {
            "showSoldPrice": store => store.page?.house?.showSoldPrice
        }),

        ...mapState({
            "showRecentListingComing": "showRecentListingComing",
            "showRecentListingNoData": "showRecentListingNoData",
            "showRecentListingLoading": "showRecentListingLoading",
            "showRecentListingData": "showRecentListingData",
            "isSoldListing": "isSoldListing"
        }),
        showPrice() {
            return (
                !this.isSoldListing ||
                (this.isSoldListing && this.showSoldPrice)
            );
        }
    }
};
</script>

<style lang="scss">
.list-table-mb.standard{
    .show_data .pagination {
        margin-bottom: 10px;
    }
    .list {
        width: 100%;
        display: table;
        font-family: var(--font-normal);
        /* table layout structure and title The style settings for  start */
        .list_item {
            display: table-row;
            justify-content: space-between;
            font-size: 12px;
            &.titile {
                font-family: var(--font-normal);
                line-height: 1;
                color: var(--color-disable);
                .address {
                    width: 205px;
                    &.show_price {
                        width: auto;
                    }
                }
                .sold_data {
                    width: 115px;
                }
                .sold_price {
                    white-space: nowrap;
                }
            }
            .cell {
                display: table-cell;
            }
            .item_cell {
                padding: 14px 0;
                border-bottom: 1px solid var(--color-border);
                height: 100%;
                vertical-align: middle;
            }
            .t_right {
                text-align: right;
            }
        }
        /* table layout structure and title The style settings for  end */
    }
    .show_data {
        position: relative;
        .loading_container {
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            z-index: var(--level-low);
            background: rgba(255, 255, 255, 0.6);
            display: flex;
            justify-content: center;
            align-items: center;
            min-height: 100px;
        }
    }
    .coming_container,
    .no_data {
        width: 100%;
        padding-top: 60px;
        padding-bottom: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .pic {
            width: 220px;
            height: 130px;
        }
        .desc {
            margin-top: 20px;
            font-size: 16px;
            padding: 0 20px;
            text-align: center;
            color: var(--color-holder);
        }
    }
}
</style>
